const mobile = '@MOBILE/'
export const TOGGLE_MOBILE = `${mobile}TOGGLE_MOBILE`
export const TOGGLE_NAV = `${mobile}TOGGLE_NAV`
export const OPEN_SCREEN = `${mobile}OPEN_SCREEN`
export const TRY_OPEN_SCREEN = `${mobile}TRY_OPEN_SCREEN`
export const HANDLE_ROWS_PER_PAGE_MODAL_INTERACTION = `${mobile}HANDLE_ROWS_PER_PAGE_MODAL_INTERACTION`
